<template>
  <div class="container">
    <notifications></notifications>
    <div class="row mt-4">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="login">
        <card class="card-login card-white">
          <template slot="header">
            <img src="img/card-primary.png" alt="" />
            <h1 class="card-title">Log in</h1>
          </template>

          <div>
            <base-input

                    name="email"
                    :error="getError('email')"
                    v-model="model.email"
                    placeholder="Email"
                    addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>

            <base-input

                    name="password"
                    :error="getError('password')"
                    v-model="model.password"
                    type="password"
                    placeholder="Password"
                    addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </div>

          <div slot="footer">

            <base-button type="primary" simple class="" size="lg" block @click="loginAndPush()">
              Войти
            </base-button>
            <hr>
            <base-button type="danger" simple class="" size="lg" block @click="passChange()">
              Сбросить пароль
            </base-button>

          </div>
        </card>
      </form>
    </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'login',
    data() {
      return {
        model: {
          email: '',
          password: '',
          subscribe: true
        }
      };
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);

      },
      async login() {
        let isValidForm = await this.$validator.validateAll();
        if (isValidForm) {
          // TIP use this.model to send it to api and perform login call
        }
      },
      async passChange(){
        let response = await axios.post('/api/admin/recovery');
        if (response.data.status === 'OK'){
          this.$notify({type: 'success', message: 'Пароль сброшен успешно '});
        }else{
          this.$notify({type: 'danger', message: 'Системная ошибка'});
        }
      },
      async loginAndPush(){

        let response = await axios.post('/api/admin/auth',{username: this.model.email,password: this.model.password});


        if(response.data.token && !response.data.err){
          if(!response.data.token.message){
            await this.$store.dispatch('FILL_TOKEN',response.data.token);

            localStorage.token = response.data.token;
            await this.$router.push('/users');
          }else{
            this.$notify({type: 'danger', message: 'Неверный логин или пароль '});
            this.model.password = '';
          }

        }else {
          this.$notify({type: 'danger', message: 'Неверный логин или пароль '});
          this.model.password = '';
        }
      }
    },
    mounted(){
      if(this.$store.getters.getToken){
        this.$router.push('/users');
      }
    }
  };
</script>
<style>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
